module.exports = __webpack_public_path__ + "static/media/personne-malentendante-questions.6deb8907.svg";